import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CashDrawerChangeRef } from "./CashDrawerChangeRef";
import type { CashDrawerChangeStaff } from "./CashDrawerChangeStaff";
import type { CashDrawerDTOBase } from "./CashDrawerDTOBase";
import type { CashDrawerTotalRef } from "./CashDrawerTotalRef";
import type { CashDrawerTotalStaff } from "./CashDrawerTotalStaff";
import type { PrinterStaff } from "./PrinterStaff";

export class CashDrawerStaff implements CashDrawerDTOBase {
  constructor(public readonly cashDrawerId: string, public readonly cashDrawerName: string, public readonly cashDrawerPrinterIp: string | null, public readonly createdOn: Date, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly printer: PrinterStaff | null, public readonly changes: Array<CashDrawerChangeStaff> | null, public readonly totals: Array<CashDrawerTotalStaff> | null) {
    this.cbiServiceContext = null;
    this.printerLoaded = this.printer != null;
    this.printerCached = this.printer;
    this.changesLoaded = this.changes != null;
    this.changesCached = this.changes;
    this.totalsLoaded = this.totals != null;
    this.totalsCached = this.totals;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private printerLoaded: boolean;
  private printerCached: PrinterStaff | null;
  private changesLoaded: boolean;
  private changesCached: Array<CashDrawerChangeStaff> | null;
  private totalsLoaded: boolean;
  private totalsCached: Array<CashDrawerTotalStaff> | null;
  async printerLazy(): Promise<PrinterStaff | null> {
    if (!this.printerLoaded) {
      this.printerCached = await this.cbiServiceContext!.cashDrawerService().getCashDrawerStaffPrinter(this.cashDrawerId);
      this.printerLoaded = true;
    }
    return this.printerCached;
  }
  async changesLazy(): Promise<Array<CashDrawerChangeStaff>> {
    if (!this.changesLoaded) {
      this.changesCached = await this.cbiServiceContext!.cashDrawerService().getCashDrawerStaffChanges(this.cashDrawerId);
      this.changesLoaded = true;
    }
    return this.changesCached!;
  }
  async totalsLazy(): Promise<Array<CashDrawerTotalStaff>> {
    if (!this.totalsLoaded) {
      this.totalsCached = await this.cbiServiceContext!.cashDrawerService().getCashDrawerStaffTotals(this.cashDrawerId);
      this.totalsLoaded = true;
    }
    return this.totalsCached!;
  }
  async addCash(amountCents: number): Promise<CashDrawerChangeRef> {
    return await this.cbiServiceContext!.cashDrawerService().addCashStaff({ drawer: { cashDrawerId: this.cashDrawerId }, amountCents: amountCents });
  }
  async dayChanges(date: Date): Promise<Array<CashDrawerChangeRef>> {
    return await this.cbiServiceContext!.cashDrawerService().dayChangesStaff({ drawer: { cashDrawerId: this.cashDrawerId }, date: date });
  }
  async openDay(date: Date, startingCents: number): Promise<CashDrawerTotalRef> {
    return await this.cbiServiceContext!.cashDrawerService().openDayStaff({ drawer: { cashDrawerId: this.cashDrawerId }, date: date, startingCents: startingCents });
  }
  async pop(): Promise<void> {
    return await this.cbiServiceContext!.cashDrawerService().popStaff({ cashDrawerId: this.cashDrawerId });
  }
  async printTest(): Promise<string> {
    return await this.cbiServiceContext!.cashDrawerService().printTestStaff({ cashDrawerId: this.cashDrawerId });
  }
  async removeCash(amountCents: number): Promise<CashDrawerChangeRef> {
    return await this.cbiServiceContext!.cashDrawerService().removeCashStaff({ drawer: { cashDrawerId: this.cashDrawerId }, amountCents: amountCents });
  }
}
